<template>
  <footer class="bg-neutral-900 text-white pt-12 pb-6">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-16 mb-8">
        <!-- 左侧：品牌信息 -->
        <div class="text-center md:text-left">
          <div class="flex items-center space-x-2 mb-3">
            <i class="fa fa-bolt text-primary text-2xl"></i>
            <span class="text-lg font-semibold">小义AI教育工具平台</span>
          </div>
          <p class="text-neutral-400 text-sm max-w-md">
            汇聚最优质的AI生成工具，连接创作者与使用者的桥梁。
          </p>
        </div>

        <!-- 右侧：友情链接 垂直布局 -->
        <div class="flex flex-col items-center md:items-start" v-if="links.length > 0">
          <h4 class="text-white font-medium mb-3">友情链接</h4>
          <div class="flex flex-col space-y-3">
            <a 
              v-for="link in links"
              :key="link.id"
              href="javascript:void(0)"
              @click="goLink(link)"
              class="text-neutral-300 hover:text-primary transition-colors flex items-center gap-2 cursor-pointer"
            >
              <span>{{ link.title }}</span>
            </a>
          </div>
        </div>
      </div>

      <div class="border-t border-neutral-800 pt-6 text-center text-neutral-500 text-xs">
        <div class="flex items-center justify-center gap-5 mb-3">
          <router-link
            to="/messages"
            class="text-neutral-400 hover:text-primary transition-colors"
          >
            <i class="fa fa-comment-o mr-1"></i>意见反馈
          </router-link>
          <router-link
            to="/messages"
            class="text-neutral-400 hover:text-primary transition-colors"
          >
            <i class="fa fa-bell-o mr-1"></i>消息中心
          </router-link>
        </div>
        <p>&copy; 2026 开发者保留所有权利。</p>
        <p class="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-neutral-500 hover:text-neutral-300 transition-colors"
          >浙ICP备2026057105号-1</a>
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=33078202004094"
            target="_blank"
            rel="noopener noreferrer"
            class="text-neutral-500 hover:text-neutral-300 transition-colors inline-flex items-center"
          >
            <i class="fa fa-shield mr-1"></i>浙公网安备33078202004094号
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      links: [],
    };
  },
  created() {
    this.getLinks();
  },
  methods: {
    async getLinks() {
      try {
        const res = await this.$axios({
          url: "links/all",
          method: "POST",
        });
        if (res.code === 200) {
          // 按 orderNum 排序，数字小的排前面
          this.links = (res.data || []).sort((a, b) => (a.orderNum || 0) - (b.orderNum || 0));
        }
      } catch (error) {
        console.error("获取友情链接失败:", error);
        this.links = [];
      }
    },
  },
};
</script>
